import React from 'react'

type Props = {
    left: number,
    bottom: number,
    size: number
}

function Spike(props : Props) {
    return (
        <div className="spike" style=
            {{
                left: `${props.left}px`,
                bottom: `${props.bottom}px`,
                height: `${props.size}px`,
                width: `${props.size}px`
            }}
        >
        </div>
    )
}

export default Spike 
